import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./polypropylene.css";

export default function Polypropylene() {
    const polypropyleneProducts = [
        {
            id: 1,
            name: "MOBILITY",
            image: "/assets/img/Polypropylene/mobility.png",
            usage: [
                {
                    title: "EV BATTERIES AND CHARGING SYSTEMS",
                    points: [
                        "Aero shields, battery cell separators, busbars, covers, enclosures lids, end plates, module boxes, side frame reinforcements, thermal runaway barriers, trays",
                        "High voltage EV power electronics, thin-wall connectors",
                        "EVSE components",
                    ],
                },
                {
                    title: "EXTERIORS",
                    points: [
                        "Body panels, bumpers, door handles, grilles, hoods and roofs, charger / tank flaps, mirror housings and brackets, pillar cladding, roof rack covers, side doors, spoilers, transparent surfaces and windows, tires, trim, trunk lids, wheel covers",
                    ],
                },
                {
                    title: "AIRCRAFT INTERIORS", 
                    points: [
                        "Aircraft seating equipment",
                        "Galley equipment",
                        "Personal safety equipment",
                    ],
                },
                {
                    title: "INTERIORS",
                    points: [
                        "Center consoles, center stacks, door panels, glove boxes, instrument panels, interior claddings and trim, steering column covers",
                        "Bezels, center console slides and rails, gears, bearings, bushings and panels",
                        "Seat foams",
                    ],
                },
                {
                    title: "SMART PANELS & LIGHTING",
                    points: [
                        "Bezels, brackets, fog lamps, heat sinks, housings, inner and outer lenses, light guides, reflectors",
                        "Front and rear panels",
                    ],
                },
                {
                    title: "SAFETY & STRUCTURES",
                    points: [
                        "Advanced Driver Assistance Systems, bumper beams, crash cans, energy absorbers",
                        "Body in white reinforcements (crossbars, hybrid pillars, rails, rocker panels)",
                        "Door modules, front-end modules, tailgates",
                    ],
                },
                {
                    title: "UNDER THE HOOD",
                    points: [
                        "Air filter box assembly, air inlet duct, air intake manifold, front engine module trim, fuel and evaporative systems, HVAC assemblies",
                        "Radiator and coolant hoses, profiles and seals",
                        "Cylinder deactivation valves, sensors, oil pumps, water pumps",
                    ],
                },
            ],
        },
        {
            id: 2,
            name: "BUILDING & CONSTRUCTION",
            image: "/assets/img/Polypropylene/construction.png",
            usage: [
                {
                    title: "INFRASTRUCTURE PIPE SYSTEMS",
                    points: [
                        "Potable water distribution networks",
                        "Sewage and drainage systems",
                        "District heating and cooling systems",
                        "Gas distribution networks",
                        "Telecommunication systems",
                        "Power cables",
                    ],
                },
                {
                    title: "INDUSTRIAL PIPE SYSTEMS",
                    points: [
                        "Chemicals",
                        "Slurries ",
                        "Industrial fluids and substances",
                        "Oil flow",
                        "Gas distribution",
                        "Water injection lines",
                    ],
                },
                {
                    title: "AGRI & AQUA-CULTURE PIPE",
                    points: [
                        "Drainage",
                        "Pressure and drip irrigation",
                        "Fish farm cages",
                    ],
                },
                {
                    title: "FOAM & LIGHTWEIGHT SOLUTIONS",
                    points: [
                        "Pipe insulation, insulation sleeves, pre-insulated pipes",
                        "Sandwich panels replacing wood and metal eg. in mobile homes, trailers",
                    ],
                },
                {
                    title: "DOMESTIC PIPE SYSTEMS",
                    points: [
                        "Conduit and protection",
                        "Reliable and safe supply of clean hot, cold water",
                        "Wastewater discharge",
                        "Heating, cooling and radiator connections",
                        "Chimney and ventilation",
                    ],
                },
            ],
        },
        {
            id: 3,
            name: "CONSUMER",
            image: "/assets/img/Polypropylene/consumer1.png",
            usage: [
                {
                    title: "LARGE APPLIANCES",
                    points: [
                        "Washing machine",
                        "Dishwasher",
                        "Fridge",
                        "Boiler",
                        "Vacuum cleaner",
                    ],
                },
                {
                    title: "SMALL APPLIANCES",
                    points: [
                        "Coffee machines",
                        "Iron",
                        "Rice cooker",
                        "Blender",
                        "Water kettle",
                        "Microwave oven",
                    ],
                },
                {
                    title: "CONSUMER GOODS",
                    points: [
                        "Durable household containers",
                        "Reusable straws",
                        "Suitcases and luggage",
                        "Eyeglasses",
                        "Toiletries",
                        "Furniture",
                    ],
                },
                {
                    title: "SPORTS & LEISURE",
                    points: [
                        "E-bikes",
                        "E-scooters",
                        "Lawnmower",
                        "Power tools",
                        "Artificial grass",
                        "Footwear",
                        "Yoga mats and foam rollers",
                    ],
                },
                {
                    title: "FOR CHILDREN",
                    points: [
                        "Toys",
                        "Baby bottles",
                        "Childrens’ car seat",
                    ],
                },
            ],
        },
        {
            id: 4,
            name: "ELECTRICAL & ELECTRONICS",
            image: "/assets/img/Polypropylene/electrical.png",
            usage: [
                {
                    title: "CONSUMER ELECTRONICS",
                    points: [
                        "5G antenna housing",
                        "Smartphones",
                        "Tablets",
                        "Printers",
                        "Laptops",
                        "Headphones",
                    ],
                },
                {
                    title: " ELECTRICAL COMPONENTS AND INFRASTRUCTURE",
                    points: [
                        "PV and solar",
                        "Inverters",
                        "Energy distribution components",
                        "EV charging infrastructure",
                        "Energy storage",
                        "Connectors",
                    ],
                },
                {
                    title: "LIGHTING",
                    points: [
                        "Spotlights and tubes",
                        "LED lightbulbs",
                        "Indoor and outdoor luminaires",
                    ],
                },
            ],
        },
        {
            id: 5,
            name: "HEALTHCARE",
            image: "/assets/img/Polypropylene/healthcare.png",
            usage: [
                {
                    title: "HEALTHCARE SOLUTIONS",
                    points: [
                        "Pharmaceutical Packaging",
                        "Drug Delivery Devices",
                        "Diagnostics Solutions",
                        "Ophthalmic Solutions",
                    ],
                },
                {
                    title: "HYGIENE SOLUTIONS",
                    points: [
                        "Baby, adult & feminine hygiene",
                        "Medical disposable surgical gowns and facemasks",
                        "Wound absorption",
                    ],
                },
            ],
        },
        {
            id: 6,
            name: "INDUSTRIAL",
            image: "/assets/img/Polypropylene/industrial.png",
            usage: [
                {
                    title: "E-BICYCLE POWER BANK ENCLOSURES AND INNER FRAMES IN LNP™ ELCRES™",
                    points: [
                        "Flame retardant",
                        "Chemical Resistant",
                    ],
                },
                {
                    title: "ELECTRIC ROBOT HOUSING IN ULTEM™",
                    points: [
                        "Dimensional Stability over wide temperature range",
                        "Chemical Resistant",
                    ],
                },
                {
                    title: " DRONE LANDING GEAR CONNECTORS IN LNP™ LUBRICOMP™",
                    points: [
                        "Low Wear and Friction",
                        "High Stiffness",
                    ],
                },
                {
                    title: "LINEAR ALPHA OLEFIN CATALYST FOR ETHYLENE OLIGOMERIZATION",
                    points: [
                        "Process reliability improvement",
                        "Long Shelf-Life",
                    ],
                },
            ],
        },
        {
            id: 7,
            name: "PACKAGING",
            image: "/assets/img/Polypropylene/packaging.jpg",
            usage: [
                {
                    title: "FOOD & BEVERAGE PACKAGING",
                    points: [
                        "Bottles",
                        "Caps and closures",
                        "Flexible food packaging",
                        "Pouches",
                        "Thin-wall cups",
                        "Foam",
                    ],
                },
                {
                    title: "CONSUMER PACKAGING - NON FOOD",
                    points: [
                        "Containers and pails",
                        "Bottles & Jars",
                        "Foam Packaging",
                        "Pouches",
                    ],
                },
                {
                    title: "TRANSPORT PACKAGING",
                    points: [
                        "Crates & Boxes",
                        "Shrink Film",
                        "Stretch Wrap Film",
                        "Heavy Duty Bags",
                        "Stretch Hood",
                        "Foam",
                    ],
                },
                {
                    title: "HEALTHCARE PACKAGING",
                    points: [
                        "Containers for small and large volume parenteral solutions",
                        "Disposable syringes",
                        "Diagnostic tubes, cartridges",
                        "Rigid and flexible packaging for pharmaceutical products",
                    ],
                },
                {
                    title: "INDUSTRIAL PACKAGING",
                    points: [
                        "Industrial Containers",
                        "Blow molded bottles for home care and industrial chemicals (HIC)",
                        "Intermediate Bulk Containers (IBC) for repeated use",
                    ],
                },
                {
                    title: "AGRICULTURAL PACKAGING",
                    points: [
                        "Greenhouse Film",
                        "Silage Wrap Film",
                    ],
                },
            ],
        },
        {
            id: 8,
            name: "AGRICULTURAL",
            image: "/assets/img/Polypropylene/agricultural.jpg",
            usage: [
                {
                    title: "NITROGENOUS FERTILIZERS AND PHOSPHATES",
                    points: [
                        "Provide essential nutrients (nitrogen and phosphorus) that promote healthy plant development",
                        "Boost productivity and crop output",
                        "Replenish key nutrients for sustained farming",
                        "Support strong root growth for better nutrient uptake",
                    ],
                },
                {
                    title: "DIFFERENTIATED PRODUCTS",
                    points: [
                        "Offer premium, specialized solutions that command better market prices",
                        "Meet specific customer needs through tailored formulations",
                        "Strengthen brand position and competitiveness",
                        "Showcase advanced technology and R&D capabilities",
                    ],
                },
                {
                    title: "TECHNICAL GRADE UREA (TGU)",
                    points: [
                        "Contains minimal impurities, ensuring consistent performance in industrial applications",
                        "Widely used in resins, adhesives, cosmetics, pharmaceuticals, and diesel exhaust fluid (AdBlue)",
                        "Provides reliable nitrogen content for precise formulations",
                        "Used in emission control systems to reduce NOx gases in vehicles and power plants",
                    ],
                },
                {
                    title: "LOW-CARBON PRODUCTS",
                    points: [
                        "Lower greenhouse gas output, helping combat climate change.",
                        "Support cleaner production and resource conservation.",
                        "Meet global carbon reduction and sustainability standards.",
                        "Often produced using renewable or optimized energy sources.",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);
    const closeModal = () => setSelectedProduct(null);

    return (
        <>
            <Breadcrumb
                title="Polypropylene Product Range"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Polypropylene Product Range</h1>
                    <p className="pp-subtitle">
                        Explore our versatile Polypropylene products designed for various
                        industries and applications.
                    </p>

                    <div className="pp-grid">
                        {polypropyleneProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>
                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>
                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div className="modal-overlay" onClick={closeModal}>
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />
                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>
                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button className="close-btn" onClick={closeModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}